import React, { forwardRef } from 'react';

import { Box } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { PendingChangeKind, PendingChangesActionType } from 'constants/pendingChanges';
import { getPendingChangeWrapperState } from 'utils/pendingChangeKind';

import PendingChangeAuthorDots from '../../common/PendingChangeAuthorDots';

import { getWrapperStyles } from './PendingChangeWrapperCDS.styles';

const PendingChangeWrapperCDS = forwardRef(
  (
    {
      children,
      isSmall = false,
      sx,
      textSelector = 'p',
      withBackground = true,
      pendingChangesActionType: propsPendingChangesActionType,
      authors = null,
      fieldLabel = '',
      changeKind: propsChangeKind = null,
      ...props
    },
    ref,
  ) => {
    const { pendingChangesActionType, changeKind } = getPendingChangeWrapperState(
      propsPendingChangesActionType,
      propsChangeKind,
    );

    return (
      <Box
        data-change-kind={changeKind}
        data-is-changed={changeKind === PendingChangeKind.DIRECT}
        data-pending-changes-action-type={pendingChangesActionType}
        ref={ref}
        sx={getWrapperStyles({
          pendingChangesActionType,
          changeKind,
          sx,
          isSmall,
          textSelector,
          withBackground,
        })}
        {...props}
      >
        {!_.isEmpty(authors) && (
          <PendingChangeAuthorDots authors={authors} fieldLabel={fieldLabel} />
        )}
        {children}
      </Box>
    );
  },
);

PendingChangeWrapperCDS.propTypes = {
  pendingChangesActionType: PropTypes.oneOf(Object.values(PendingChangesActionType)),
  textSelector: PropTypes.string,
  sx: PropTypes.object,
  isSmall: PropTypes.bool,
  withBackground: PropTypes.bool,
  authors: PropTypes.arrayOf(PropTypes.object),
  fieldLabel: PropTypes.string,
  // Why the value is pending: a Direct change is highlighted, a Recalculated one underlined. Alone it marks the
  // value modified.
  changeKind: PropTypes.oneOf(Object.values(PendingChangeKind)),
};
export default PendingChangeWrapperCDS;
